import React from "react";
import PageHero from "../components/PageHero";
import SectionHeader from "../components/SectionHeader";
import CTASection from "../components/CTASection";

const SECTIONS = [
  { t: "Smart Classroom Solutions", d: "End-to-end digital classroom fit-out with content and devices." },
  { t: "Interactive Smart Panels", d: "Latest interactive panels for schools, colleges, training centres." },
  { t: "Computers & Laptops", d: "Desktops, laptops, all-in-ones for labs, offices and admin blocks." },
  { t: "Printers & Peripherals", d: "Multi-function printers, scanners, projectors, accessories." },
  { t: "CCTV Surveillance", d: "IP and analog cameras, DVR/NVR, public area surveillance." },
  { t: "Biometric Systems", d: "Attendance and access control for institutions and offices." },
  { t: "Networking", d: "Switches, routers, structured cabling and Wi-Fi setup support." },
  { t: "UPS & Power Backup", d: "Online/offline UPS, batteries, inverters and distribution." },
];

export default function ITCCTV() {
  return (
    <div>
      <PageHero
        kicker="IT, CCTV & Smart Classroom"
        title="Digital, Surveillance & Power Backup Solutions"
        description="Smart classroom solutions, IT supply, CCTV surveillance, biometric systems, networking and power backup for institutions and offices."
        primary={{ to: "/submit", label: "Submit IT / CCTV Requirement" }}
        secondary={{ to: "/products", label: "All Categories" }}
        image="/img/smart-classroom.png"
      />
      <section className="section">
        <div className="container-x">
          <SectionHeader kicker="Capabilities" title="IT, CCTV & Smart Classroom Categories" />
          <div className="grid-cards mt-8">
            {SECTIONS.map((s) => (
              <div key={s.t} className="card-premium p-5">
                <div className="font-semibold text-navy text-base">{s.t}</div>
                <div className="divider-gold" />
                <p className="text-sm text-[var(--melopa-muted)]">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CTASection title="Modernise classrooms or campuses?" description="Smart panels, surveillance, computers and networking — share your requirement and we'll respond with a suitable plan." />
    </div>
  );
}
